import { useState } from 'react';
import DataTable, { TableColumn } from 'react-data-table-component';
import { useParams } from 'react-router-dom';
import {
  Button,
  Card,
  CardBody,
  Container
} from 'reactstrap';
import BetterBreadcrumb from 'src/components/Common/BetterBreadCrumb';
import { actionColumnStyles, dataTableCustomStyles } from 'src/components/Common/FixedActionColumn';
import { useAppSelector } from 'src/rtk/app/hook';
import { useGetScheduleListForExaminerQuery } from 'src/rtk/features/logbookMonitoringReport/logbookMonitoringReportApi';
import loader from '../../assets/images/loader.gif';
import AssessmentViewModal from './AssessmentViewModal';
import { InterviewReportPDF } from './InterviewReportPDF';
import ProgressReportInterview from './ProgressReportInterview';


const TraineesScheduleList = () => {

  const { id: rowId } = useParams<{ id: string }>();

  const authUser = useAppSelector((state) => state.auth.user);

  const [showTakeInterviewForm, setShowTakeInterviewForm] = useState<boolean>(false);
  const [showViewModal, setShowViewModal] = useState<boolean>(false);
  const [rowData, setRowData] = useState<any>(null);
  const [reportId, setReportId] = useState<string>('');

  const [page, setPage] = useState<any>(1);
  const [limit, setLimit] = useState<any>(10);
  const [search, setSearch] = useState('');

  const generateQueryUrl = () => {
    return `page=${page}&paginate_per_page=${limit}${search}`;
  };

  const handlePageChange = (page: number) => {
    setPage(page);
  };

  const handlePerRowsChange = (newPerPage: number, page: number) => {
    setLimit(newPerPage);
    setPage(page);
  };

  const { data: scheduleListData, isLoading } = useGetScheduleListForExaminerQuery(generateQueryUrl());

  const filteredData = scheduleListData?.data?.data?.find((item: any) => item?.id === rowId);

  console.log(filteredData)
  const columns: TableColumn<any>[] = [
    {
      name: <div>Sl. No.</div>,
      width: '80px',
      cell: (row, index) => <strong>{index + 1}</strong>,
    },

    {
      name: <div>Trainee Name</div>,
      selector: (row) => row?.registration?.personal_info?.full_name,
      wrap: true,
    },

    {
      name: <div>BMDC Number</div>,
      selector: (row) => row?.registration?.bmdc_registration_no,
      wrap: true,
    },

    {
      name: <div>Session & Year</div>,
      selector: (row) => `${row?.registration?.current_session_and_supervisor_info?.session_name} - ${row?.registration?.current_session_and_supervisor_info?.session_year}`,
      wrap: true,
    },
    ...(authUser?.type !== 'Operation' ? [
      {
        name: <div>Evaluated Status</div>,
        selector: (row: any) => row?.evaluation_status,
        cell: (row: any) => {
          switch (row?.evaluation_status) {
            case true:
              return (
                <>
                  <div className="badge rounded-pill d-inline-block badge-approved font-size-12 fw-medium">
                    {'Evaluated'}
                  </div>
                </>
              );

            case false:
              return (
                <>
                  <div className="badge rounded-pill d-inline-block badge-pending font-size-12 fw-medium">
                    {'Not Evaluated'}
                  </div>
                </>
              );

            default:
              return (
                <>
                  <div className="badge rounded-pill d-inline-block badge-pending font-size-12 fw-medium">
                    {'Not Evaluated'}
                  </div>
                </>
              );
          }
        },
        wrap: true,
      }] : []),

    ...(authUser?.type !== 'Operation' ? [
      {
        name: <div>Average Marking</div>,
        selector: (row: any) => row?.examiner_assessment?.average_marking,
        cell: (row: any) => {
          return (
            <>
              <div className="badge rounded-pill d-inline-block badge-draft font-size-12 fw-medium">
                {row?.examiner_assessment?.average_marking ? row?.examiner_assessment?.average_marking : 'N/A'}
              </div>
            </>
          );
        },
        wrap: true,
      }] : []),

    ...(authUser?.type !== 'Operation' ? [
      {
        name: <div>Action</div>,
        style: actionColumnStyles,
        width: '350px',
        cell: (row: any, index: number) => (
          <div className='d-flex gap-1 my-1'>
            <Button
              color="info"
              size="sm"
              outline
              onClick={() => {
                setShowViewModal(true);
                setRowData(row);
              }}
            >
              View
            </Button>
            <Button
              color="success"
              size="sm"
              outline
              onClick={() => {
                setShowTakeInterviewForm(true);
                setRowData(row);
              }}
            >
              Take Progress Report Interview
            </Button>

            {
              (rowData?.id === row.id && showViewModal) && (
                <AssessmentViewModal
                  isOpen={showViewModal}
                  toggle={() => setShowViewModal(false)}
                  traineeData={rowData}
                />
              )
            }

            {
              (rowData?.id === row.id && showTakeInterviewForm) && (
                <ProgressReportInterview
                  isOpen={showTakeInterviewForm}
                  toggle={() => setShowTakeInterviewForm(false)}
                  traineeData={rowData}
                />
              )
            }
          </div>
        ),
      }] : []),

    ...(authUser?.type === 'Operation' ? [
      {
        name: <div>Result</div>,
        selector: (row: any) => row?.result,
        cell: (row: any) => {
          switch (row?.result) {
            case 'Pass':
              return (
                <>
                  <div className="badge rounded-pill d-inline-block badge-approved font-size-12 fw-medium">
                    {row?.result}
                  </div>
                </>
              );

            case 'Fail':
              return (
                <>
                  <div className="badge rounded-pill d-inline-block badge-pending font-size-12 fw-medium">
                    {row?.result}
                  </div>
                </>
              );

            default:
              return (
                <>
                  <div className="badge rounded-pill d-inline-block badge-pending font-size-12 fw-medium">
                    {'Not Evaluated'}
                  </div>
                </>
              );
          }
        },
        wrap: true,
      }] : []),

    ...(authUser?.type === 'Operation' ? [
      {
        name: <div>Action</div>,
        style: actionColumnStyles,
        cell: (row: any, index: number) => (
          <div className='d-flex my-1'>

            <Button
              color="success"
              size="sm"
              onClick={() => {
                setReportId(row?.id);
              }}
              disabled={row?.itmc_approval_status !== 'Approved'}
            >
              <i className="fa-solid fa-print" /> View Report
            </Button>

            {
              reportId === row?.id && (
                <InterviewReportPDF traineeData={row} setReportId={setReportId} />
              )
            }
          </div>
        ),
      }
    ] : []),
  ];

  return (
    <div className="page-content">
      {isLoading ? (
        <div className="overlay">
          <img src={loader} alt="Loading" height={100} width={300} />
        </div>
      ) : null}
      <Container fluid>
        <BetterBreadcrumb
          breadcrumbItem={[{ link: '/interview-schedule-create', name: 'Schedule Details' }]}
          title={'Trainee List'}
        />

        <Card>
          <CardBody>
            <DataTable
              columns={columns}
              data={filteredData?.participants || []}
              customStyles={dataTableCustomStyles}
              // pagination
              // paginationServer
              progressPending={isLoading}
              expandOnRowClicked
              highlightOnHover
              // onChangePage={handlePageChange}
              // onChangeRowsPerPage={handlePerRowsChange}
              // paginationTotalRows={approvalList?.data?.total}
              // paginationRowsPerPageOptions={[2, 5, 10, 20, 50, 100, 200]}
              responsive
              persistTableHead={true}
            />
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default TraineesScheduleList;
